// Sitemap page

import React from 'react'

function Sitemap() {
  return (
    <div>
      This is sitemap page.
    </div>
  )
}

export default Sitemap
